import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  Label,
  SelectNative,
  SelectNativeOption,
} from '@americanexpress/dls-react';
import TravelCreditDetail from './TravelCreditDetail';

const MultipleTravelCredit = ({
  travelCreditsData,
  membershipData,
  hasTravelCreditCenturionCardArt,
}) => {
  const { formatMessage } = useIntl();
  const [selectedTravelCreditIndex, setSelectedTravelCreditIndex] = useState(0);
  const selectedTravelCredit = travelCreditsData[selectedTravelCreditIndex] || {};

  return (
    <div className="margin-b">
      <Label htmlFor="multipleTravelCreditDropdown">
        {formatMessage({ id: 'travelCreditTab.heading' }).toUpperCase()}
      </Label>
      <SelectNative
        id="multipleTravelCreditDropdown"
        value={selectedTravelCreditIndex.toString()}
        onChange={(event) => setSelectedTravelCreditIndex(Number.parseInt(event.target.value, 10))}
      >
        {travelCreditsData.map((credit, index) => (
          <SelectNativeOption value={index.toString()} key={credit.awardName}>
            {credit.awardName}
          </SelectNativeOption>
        ))}
      </SelectNative>
      <TravelCreditDetail
        membershipData={membershipData}
        selectedTravelCredit={selectedTravelCredit}
        hasTravelCreditCenturionCardArt={hasTravelCreditCenturionCardArt}
      />
    </div>
  );
};

MultipleTravelCredit.propTypes = {
  travelCreditsData: PropTypes.arrayOf({}),
  membershipData: PropTypes.shape({
    displayAccountNumber: PropTypes.string,
    cardArtCdnLink: PropTypes.string,
    travelCredits: PropTypes.arrayOf(
      PropTypes.shape({
        awardName: PropTypes.string,
      })
    ),
  }),
  hasTravelCreditCenturionCardArt: PropTypes.bool.isRequired,
};

export default MultipleTravelCredit;
